const TYPE_MAP = {
  danger: { icon: 'error', title: 'Error' },
  warning: { icon: 'warning', title: 'Atención' },
  success: { icon: 'success', title: 'Éxito' },
  info: { icon: 'info', title: 'Aviso' },
  primary: { icon: 'info', title: 'Aviso' },
  secondary: { icon: 'info', title: 'Aviso' },
  light: { icon: 'info', title: 'Aviso' },
  dark: { icon: 'info', title: 'Aviso' }
};

const directSubmit = HTMLFormElement.prototype.submit;

function buildAlertConfig(element) {
  const variant = Object.keys(TYPE_MAP).find((type) => element.classList.contains(`alert-${type}`));
  const fallback = TYPE_MAP.info;
  const { icon, title } = TYPE_MAP[variant] || fallback;
  const dataTitle = element.dataset.alertTitle?.trim();
  const dataIcon = element.dataset.alertIcon?.trim();
  const confirmText = element.dataset.alertConfirm || 'Aceptar';

  return {
    icon: dataIcon || icon,
    title: dataTitle || title,
    html: element.innerHTML.trim(),
    confirmButtonText: confirmText,
    allowOutsideClick: false,
    allowEscapeKey: true
  };
}

function showAlertsSequentially(alerts, index = 0) {
  if (!alerts.length || index >= alerts.length) return;
  window.Swal.fire(alerts[index]).then(() => {
    showAlertsSequentially(alerts, index + 1);
  });
}

function setupFlashAlerts() {
  const elements = Array.from(document.querySelectorAll('.alert'))
    .filter((element) => element.dataset.alertStatic !== 'true');
  if (!elements.length) return;

  const alerts = elements.map((element) => {
    // Evita mostrar alertas duplicadas si se re-renderiza el contenedor.
    element.dataset.alertProcessed = 'true';
    const config = buildAlertConfig(element);
    element.remove();
    return config;
  });

  if (alerts.length === 1) {
    window.Swal.fire(alerts[0]);
  } else {
    showAlertsSequentially(alerts);
  }
}

function setupConfirmations() {
  const forms = Array.from(document.querySelectorAll('form[data-confirm]'));
  if (!forms.length) return;

  forms.forEach((form) => {
    if (form.dataset.confirmBound === 'true') return;

    form.addEventListener('submit', (event) => {
      if (form.dataset.confirmSkip === 'true') {
        form.dataset.confirmSkip = '';
        return;
      }

      event.preventDefault();
      const title = form.dataset.confirmTitle || 'Confirmar acción';
      const text = form.dataset.confirm || '¿Deseas continuar?';
      const confirmButtonText = form.dataset.confirmButton || 'Sí, continuar';
      const cancelButtonText = form.dataset.cancelButton || 'Cancelar';
      const icon = form.dataset.confirmIcon || 'warning';

      window.Swal.fire({
        icon,
        title,
        text,
        showCancelButton: true,
        confirmButtonText,
        cancelButtonText,
        focusCancel: true
      }).then((result) => {
        if (result.isConfirmed) {
          form.dataset.confirmSkip = 'true';
          directSubmit.call(form);
        }
      });
    });

    form.dataset.confirmBound = 'true';
  });
}

export function initAlerts() {
  if (typeof window === 'undefined' || typeof window.Swal === 'undefined') return;

  setupFlashAlerts();
  setupConfirmations();
}
